module.exports = __webpack_public_path__ + "img/angle-up.435df71f.svg";